export interface Governorate {
  id: string;
  name_ar: string;
  name_en: string;
  cities: string[];
  delivery_fee?: number | null;
}

export const EGYPTIAN_GOVERNORATES: Governorate[] = [
  {
    id: 'cairo',
    name_ar: 'القاهرة',
    name_en: 'Cairo',
    delivery_fee: 80,
    cities: [
      'مصر الجديدة',
      'النزهة',
      'غرب مدينة نصر',
      'شرق مدينة نصر',
      'عين شمس',
      'السلام أول',
      'السلام ثان',
      'المطرية',
      'المرج',
      'منشأة ناصر',
      'الوايلي',
      'وسط القاهرة',
      'بولاق',
      'غرب القاهرة',
      'عابدين',
      'الأزبكية',
      'الموسكي',
      'باب الشعرية',
      'شبرا',
      'الزاوية الحمراء',
      'حدائق القبة',
      'روض الفرج',
      'الشرابية',
      'الساحل',
      'الزيتون',
      'الأميرية',
      'مصر القديمة',
      'الخليفة',
      'المقطم',
      'البساتين',
      'دار السلام',
      'السيدة زينب',
      'التبين',
      'حلوان',
      'المعصرة',
      'المعادي',
      'طرة',
      '15 مايو',
      'القاهرة الجديدة',
      'الشروق',
      'بدر'
    ]
  },
  {
    id: 'giza',
    name_ar: 'الجيزة',
    name_en: 'Giza',
    delivery_fee: 80,
    cities: [
      'مركز أبو النمرس',
      'مركز البدرشين',
      'مركز العياط',
      'مركز الصف',
      'مركز أطفيح',
      'مركز منشأة القناطر',
      'مركز أوسيم',
      'مركز كرداسة',
      'مركز الواحات البحرية',
      'حي شمال الجيزة',
      'حي جنوب الجيزة',
      'حي الدقي',
      'حي العجوزة',
      'حي الهرم',
      'حي بولاق الدكرور',
      'حي العمرانية',
      'حي الطالبية',
      'حي الوراق',
      'حي إمبابة',
      'مدينة الجيزة',
      'مدينة 6 أكتوبر',
      'مدينة الشيخ زايد',
      'مدينة الحوامدية',
      'مدينة البدرشين',
      'مدينة الصف',
      'مدينة أطفيح',
      'مدينة العياط',
      'مدينة أوسيم',
      'مدينة كرداسة',
      'مدينة منشأة القناطر',
      'مدينة أبو النمرس',
      'حدائق أكتوبر',
      'أكتوبر الجديدة',
      'سفنكس الجديدة'
    ]
  },
  {
    id: 'qalyubia',
    name_ar: 'القليوبية',
    name_en: 'Qalyubia',
    delivery_fee: 95,
    cities: [
      'بنها',
      'طوخ',
      'قليوب',
      'شبين القناطر',
      'كفر شكر',
      'الخانكة',
      'القناطر الخيرية',
      'شبرا الخيمة',
      'الخصوص',
      'قها',
      'العبور'
    ]
  },
  {
    id: 'alexandria',
    name_ar: 'الإسكندرية',
    name_en: 'Alexandria',
    delivery_fee: 95,
    cities: [
      'حي المنتزه أول',
      'حي المنتزه ثان',
      'حي شرق',
      'حي وسط',
      'حي الجمرك',
      'حي غرب',
      'حي العجمي',
      'حي العامرية أول',
      'حي العامرية ثان',
      'مركز ومدينة برج العرب',
      'مدينة برج العرب الجديدة'
    ]
  },
  {
    id: 'beheira',
    name_ar: 'البحيرة',
    name_en: 'Beheira',
    delivery_fee: 95,
    cities: [
      'دمنهور',
      'كفر الدوار',
      'رشيد',
      'إدكو',
      'أبو حمص',
      'أبو المطامير',
      'حوش عيسى',
      'الدلنجات',
      'إيتاي البارود',
      'شبراخيت',
      'الرحمانية',
      'المحمودية',
      'كوم حمادة',
      'بدر',
      'وادي النطرون',
      'النوبارية الجديدة',
      'رشيد الجديدة'
    ]
  },
  {
    id: 'dakahlia',
    name_ar: 'الدقهلية',
    name_en: 'Dakahlia',
    delivery_fee: 95,
    cities: [
      'المنصورة',
      'طلخا',
      'ميت غمر',
      'دكرنس',
      'أجا',
      'بلقاس',
      'شربين',
      'المنزلة',
      'المطرية',
      'بني عبيد',
      'منية النصر',
      'تمي الأمديد',
      'نبروه',
      'السنبلاوين',
      'الجمالية',
      'ميت سلسيل',
      'الكردي',
      'جمصة'
    ]
  },
  {
    id: 'sharqia',
    name_ar: 'الشرقية',
    name_en: 'Sharqia',
    delivery_fee: 95,
    cities: [
      'الزقازيق',
      'أبو حماد',
      'أبو كبير',
      'الحسينية',
      'بلبيس',
      'ديرب نجم',
      'فاقوس',
      'كفر صقر',
      'منيا القمح',
      'ههيا',
      'مشتول السوق',
      'الإبراهيمية',
      'أولاد صقر',
      'العاشر من رمضان',
      'الصالحية الجديدة',
      'القنايات',
      'القرين'
    ]
  },
  {
    id: 'gharbia',
    name_ar: 'الغربية',
    name_en: 'Gharbia',
    delivery_fee: 95,
    cities: [
      'طنطا',
      'المحلة الكبرى',
      'كفر الزيات',
      'زفتى',
      'بسيون',
      'السنطة',
      'سمنود',
      'قطور'
    ]
  },
  {
    id: 'menofia',
    name_ar: 'المنوفية',
    name_en: 'Menofia',
    delivery_fee: 95,
    cities: [
      'شبين الكوم',
      'منوف',
      'أشمون',
      'قويسنا',
      'تلا',
      'بركة السبع',
      'الباجور',
      'الشهداء',
      'السادات',
      'سرس الليان'
    ]
  },
  {
    id: 'kafr_el_sheikh',
    name_ar: 'كفر الشيخ',
    name_en: 'Kafr El Sheikh',
    delivery_fee: 95,
    cities: [
      'كفر الشيخ',
      'دسوق',
      'فوه',
      'مطوبس',
      'قلين',
      'سيدي سالم',
      'الرياض',
      'بيلا',
      'الحامول',
      'بلطيم',
      'برج البرلس',
      'مصيف بلطيم',
      'سيدي غازي',
      'مسير'
    ]
  },
  {
    id: 'damietta',
    name_ar: 'دمياط',
    name_en: 'Damietta',
    delivery_fee: 95,
    cities: [
      'دمياط',
      'فارسكور',
      'كفر سعد',
      'الزرقا',
      'كفر البطيخ',
      'رأس البر',
      'عزبة البرج',
      'الروضة',
      'السرو',
      'ميت أبو غالب',
      'دمياط الجديدة'
    ]
  },
  {
    id: 'port_said',
    name_ar: 'بورسعيد',
    name_en: 'Port Said',
    delivery_fee: 100,
    cities: [
      'حي الشرق',
      'حي العرب',
      'حي المناخ',
      'حي الضواحي',
      'حي الجنوب',
      'حي الزهور',
      'حي غرب',
      'مدينة بورفؤاد'
    ]
  },
  {
    id: 'ismailia',
    name_ar: 'الإسماعيلية',
    name_en: 'Ismailia',
    delivery_fee: 100,
    cities: [
      'الإسماعيلية',
      'فايد',
      'القنطرة شرق',
      'القنطرة غرب',
      'التل الكبير',
      'أبو صوير',
      'القصاصين الجديدة',
      'نفيشة',
      'سرابيوم'
    ]
  },
  {
    id: 'suez',
    name_ar: 'السويس',
    name_en: 'Suez',
    delivery_fee: 100,
    cities: [
      'حي السويس',
      'حي الأربعين',
      'حي عتاقة',
      'حي الجناين',
      'حي فيصل'
    ]
  },
  {
    id: 'north_sinai',
    name_ar: 'شمال سيناء',
    name_en: 'North Sinai',
    delivery_fee: null,
    cities: [
      'العريش',
      'بئر العبد',
      'الشيخ زويد',
      'رفح',
      'الحسنة',
      'نخل'
    ]
  },
  {
    id: 'south_sinai',
    name_ar: 'جنوب سيناء',
    name_en: 'South Sinai',
    delivery_fee: 160,
    cities: [
      'الطور',
      'شرم الشيخ',
      'دهب',
      'نويبع',
      'طابا',
      'سانت كاترين',
      'رأس سدر',
      'أبو رديس',
      'أبو زنيمة',
      'كاترين'
    ]
  },
  {
    id: 'fayoum',
    name_ar: 'الفيوم',
    name_en: 'Fayoum',
    delivery_fee: 110,
    cities: [
      'الفيوم',
      'إطسا',
      'سنورس',
      'طامية',
      'أبشواي',
      'يوسف الصديق'
    ]
  },
  {
    id: 'beni_suef',
    name_ar: 'بني سويف',
    name_en: 'Beni Suef',
    delivery_fee: 110,
    cities: [
      'بني سويف',
      'الواسطى',
      'ناصر',
      'إهناسيا',
      'ببا',
      'سمسطا',
      'الفشن'
    ]
  },
  {
    id: 'minya',
    name_ar: 'المنيا',
    name_en: 'Minya',
    delivery_fee: 110,
    cities: [
      'المنيا',
      'مغاغة',
      'بني مزار',
      'مطاي',
      'سمالوط',
      'أبو قرقاص',
      'ملوي',
      'دير مواس',
      'العدوة'
    ]
  },
  {
    id: 'asyut',
    name_ar: 'أسيوط',
    name_en: 'Asyut',
    delivery_fee: 110,
    cities: [
      'أسيوط',
      'ديروط',
      'القوصية',
      'منفلوط',
      'أبنوب',
      'الفتح',
      'ساحل سليم',
      'البداري',
      'صدفا',
      'الغنايم',
      'أبو تيج'
    ]
  },
  {
    id: 'new_valley',
    name_ar: 'الوادي الجديد',
    name_en: 'New Valley',
    delivery_fee: null,
    cities: [
      'الخارجة',
      'الداخلة',
      'الفرافرة',
      'باريس',
      'بلاط'
    ]
  },
  {
    id: 'sohag',
    name_ar: 'سوهاج',
    name_en: 'Sohag',
    delivery_fee: 110,
    cities: [
      'سوهاج',
      'أخميم',
      'البلينا',
      'المراغة',
      'المنشأة',
      'جرجا',
      'دار السلام',
      'جهينة',
      'ساقلتة',
      'طهطا',
      'طما',
      'العسيرات'
    ]
  },
  {
    id: 'qena',
    name_ar: 'قنا',
    name_en: 'Qena',
    delivery_fee: 130,
    cities: [
      'قنا',
      'أبو تشت',
      'فرشوط',
      'نجع حمادي',
      'الوقف',
      'دشنا',
      'قفط',
      'قوص',
      'نقادة'
    ]
  },
  {
    id: 'luxor',
    name_ar: 'الأقصر',
    name_en: 'Luxor',
    delivery_fee: 110,
    cities: [
      'الأقصر',
      'الزينية',
      'البياضية',
      'القرنة',
      'أرمنت',
      'إسنا',
      'الطود'
    ]
  },
  {
    id: 'aswan',
    name_ar: 'أسوان',
    name_en: 'Aswan',
    delivery_fee: 130,
    cities: [
      'أسوان',
      'دراو',
      'كوم أمبو',
      'نصر النوبة',
      'إدفو',
      'أبو سمبل السياحية'
    ]
  },
  {
    id: 'red_sea',
    name_ar: 'البحر الأحمر',
    name_en: 'Red Sea',
    delivery_fee: 130,
    cities: [
      'الغردقة',
      'رأس غارب',
      'سفاجا',
      'القصير',
      'مرسى علم',
      'الشلاتين',
      'حلايب'
    ]
  },
  {
    id: 'matrouh',
    name_ar: 'مطروح',
    name_en: 'Matrouh',
    delivery_fee: 160,
    cities: [
      'مرسى مطروح',
      'الحمام',
      'العلمين',
      'الضبعة',
      'النجيلة',
      'سيدي براني',
      'السلوم',
      'سيوة'
    ]
  }
];

export const getDeliveryFeeByGov = (govNameOrId?: string): { fee: number | null; textAr: string; textEn: string } => {
  if (!govNameOrId) {
    return { fee: null, textAr: 'لم يحدد بعد', textEn: 'To be determined' };
  }
  const gov = EGYPTIAN_GOVERNORATES.find(g => g.name_ar === govNameOrId || g.id === govNameOrId);
  if (!gov || gov.delivery_fee === null || gov.delivery_fee === undefined) {
    return { fee: null, textAr: 'لم يحدد بعد', textEn: 'To be determined' };
  }
  return { fee: gov.delivery_fee, textAr: `${gov.delivery_fee} ج.م`, textEn: `${gov.delivery_fee} EGP` };
};
